import axios from 'axios';
import { getHeaders } from '../../pages/App';
import {
    FetchReviewsParams,
    GetCsqaPayload,
    ReviewFetchResponse,
    UpdateReviewPayload,
} from './types';
import settings from '../../settings.json';

const settingEnv = (settings as any)[window.location.host] || settings.default;
const { api_prefix: apiPrefix } = settingEnv;

export const fetchReviews = async (
    startDate?: string,
    endDate?: string,
    associateEmailFilter?: string,
    supervisorEmailFilter?: string,
    evaluatorEmailFilter?: string,
    associateSiteFilter?: string,
    viewAll?: boolean,
): Promise<ReviewFetchResponse | undefined> => {
    try {
        const params: FetchReviewsParams = {
            ...(startDate && endDate && { startDate, endDate }),
            ...(associateEmailFilter && { associateEmailFilter }),
            ...(supervisorEmailFilter && { supervisorEmailFilter }),
            ...(evaluatorEmailFilter && { evaluatorEmailFilter }),
            ...(associateSiteFilter && { associateSiteFilter }),
            ...(viewAll && { viewAll }),
        };

        const headers = await getHeaders();
        const { data } = await axios.get<ReviewFetchResponse>(apiPrefix + '/api/csqa', { headers, params });
        return data;
    } catch (e: unknown) {
        console.error('There was a problem with your review fetch', e);
        return undefined;
    }
};

export const fetchReviewDetails = async (id: string, createdTimestamp: number): Promise<GetCsqaPayload | null> => {
    try {
        const headers = await getHeaders();
        const params = { id, createdTimestamp };
        const { data } = await axios.get<GetCsqaPayload>(apiPrefix + '/api/csqa-review', { headers, params });
        return data;
    } catch (e: unknown) {
        console.error('There was a problem fetching CSQA details', e);
        return null;
    }
};

export const updateReview = async (request: UpdateReviewPayload): Promise<void> => {
    const headers = await getHeaders();
    try {
        await axios.post(apiPrefix + '/api/csqa', request, { headers });
    } catch (e: unknown) {
        console.error('There was a problem updating the review', e);
    }
};
